import { LinearProgress } from "@mui/material";

const Loader = () => {
  return <LinearProgress color={"primary"} />;
}

export default Loader;